import { BareActionContext } from 'vuex-typex'
import { FeedState } from '../state'
import { RootState } from '@/store'
import feedStore from '../feed-store'
import { IUser } from '@/model/user'

export default async function setFeedUser(context: BareActionContext<FeedState, RootState>, user: IUser | null) {

    feedStore.commitSetUser({ user: user })
  
    return
}
